import request from '@/utils/request'

export function login(data){
    return request({url:'/login',method:'post',data})
}

export function register(data){
    return request({
        url:'/register',
        method:'post',
        data
    })
}

export function getInfo(token) {
    return request({
        url: '/api/hr/getUserInfo',
        method: 'get',
        params: { token }
    })
}
  
export function logout() {
    return request({
        url: '/logout',
        method: 'post'
    })
}

export function fetchUserList(query){
    return request({
        url:'/api/hr/getUserList',
        method:'get',
        params:query
    })
}

export function fetchRegUserList(query){
    return request({
        url:'/api/hr/getRegUserList',
        method:'get',
        params:query
    })
}

export function createUser(data) {
    return request({
        url:'/api/hr/addUser',
        method:'post',
        data
    })
}

export function grantUser(data) {
    return request({
        url:'/api/hr/grantUser',
        method:'post',
        data
    })
}

export function updateUserContactInfo(data) {
    return request({
        url:'/api/hr/modifyContactInfo',
        method:'post',
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        data
    })
}

export function deleteUser(data) {
    return request({
        url:'/api/hr/removeUser',
        method:'post',
        data
    })
}

export function updateUserInfo(data) {
    return request({
        url:'/api/hr/editUserInfo',
        method:'post',
        data
    })
}

export function uploadResume(data){
    return request({
        url:'/api/hr/uploadResume',
        method:'post',
        data
    })
}

export function fetchUserInfo(){
    return request({
        url:'/api/hr/getUserDetail',
        method:'get'
    })
}

export function fetchUserInfoById(query){
    return request({
        url:'/api/hr/getUserDetailById',
        method:'get',
        params:query
    })
}

export function fetchStaffList(query){
    return request({
        url:'/api/hr/getStaffs',
        method:'get',
        params:query
    })
}

export function fetchOtherStaffList(query){
    return request({
        url:'/api/hr/getOtherStaffs',
        method:'get',
        params:query
    })
}

export function fetchStaffListByRole(query){
    return request({
        url:'/api/hr/getAllStaffsByRole',
        method:'get',
        params:query
    })
}


export function fetchRecruitList(query){
    return request({
        url:'/api/hr/getRecruitList',
        method:'get',
        params:query
    })
}

export function createRecruit(data) {
    return request({
        url:'/api/hr/addRecruit',
        method:'post',
        data
    })
}

export function updateRecruit(data) {
    return request({
        url:'/api/hr/editRecruit',
        method:'post',
        data
    })
}

export function deleteRecruit(data) {
    return request({
        url:'/api/hr/removeRecruit',
        method:'post',
        data
    })
}